<template>
<div>
  <!-- <loading
        :show="show"
        :label="label"
      /> -->
  <div class="main">
    <div class="main-c">
      <div class="top">
        <div class="classify">
          {{ getStrateTypeName(typeID) }}
          <span class="slant">\</span>
          <span class="news"> {{ getStrateTypeNameEnglish(typeID) }} </span>
        </div>
        <div class="crumbs">
          您的位置：>
          <router-link to="/">
            官网首页
          </router-link>
          <span class="sep">></span><router-link :to="{path:'/strate/list',query: {typeID: typeID}}">
            {{ getStrateTypeName(typeID) }}
          </router-link>
          <span class="sep">></span>详情
        </div>
      </div>
      <div class="article">
        <h1 class="tit">
          {{ item.title }}
        </h1>
        <div class="mod-info">
          <span class="author">{{ item.adminUserName }}</span>发布于
          <span class="data">{{ item.createTime | dateformat('MM/DD') }}</span>
        </div>
        <div
          class="mod-article"
          v-html="item.body"
        />
      </div>
    </div>
  </div>
  </div>
</template>
<script>
import loading from 'vue-full-loading'
import { getStrateTypeName, getStrateTypeNameEnglish } from '../../utils/utils'

export default {
  components: {
    loading
  },
  data () {
    return {
      typeID: parseInt(this.$route.query.tid) || 0,
      id: parseInt(this.$route.query.id) || 0,
      item: {}
      // show: false,
      // label: '加载中...'
    }
  },
  created () {
    this.getContent()
  },
  methods: {

    getContent () {
      // this.show = true
      // console.log(this.show)
      this.bus.$emit('loading', true)
      this.$api.getStrateContent({ id: this.id }).then(res => {
        this.item = res.data.item
        // console.log(this.show)
        // this.show = false
        // console.log(this.show)
        this.bus.$emit('loading', false)
      })
    },
    getStrateTypeName,
    getStrateTypeNameEnglish
  }
}
</script>



// WEBPACK FOOTER //
// src/components/strate/content.vue